import {createFileRoute} from '@tanstack/react-router';

import {InboxPage} from '@/modules/inbox/pages/InboxPage';

export const Route = createFileRoute('/_authenticated/inbox/')({
  component: InboxPage,
});
